export default "__VITE_ASSET__CN75uC8H__"